import { render, staticRenderFns } from "./GISMap3.vue?vue&type=template&id=220c28bd&"
import script from "./GISMap3.vue?vue&type=script&lang=js&"
export * from "./GISMap3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports